import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SharedDataService, DocumentsService } from '../../all-services';
import {
  DocumentStatut,
  PafDocument,
  PS_Supplier_Regul_Docs_Result,
  Supplier,
  SimpleReponseResult,
  SupplierDocument,
  SupplierDocumentsWF,
  DocTyp,
  ChangeStatutParams
} from '../../all-models';
import { forkJoin, of } from 'rxjs';  // RxJS 6 syntax
import moment from 'moment';
import { formatDate } from '@angular/common';
import { finalize } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { saveAs } from '@progress/kendo-file-saver';


@Component({
  selector: 'supplier-doc-row',
  templateUrl: './supplier-doc-row.component.html',
  styleUrls: ['./supplier-doc-row.component.scss']
})
export class SupplierDocRowComponent {
  @Input() lstPafDocuments!: PafDocument[];
  @Input() lstDocTyps!: DocTyp[];
  @Input() lstDocStatuts!: DocumentStatut[];
  @Input() supplier: Supplier = new Supplier();
  @Input() supplierDoc?: PS_Supplier_Regul_Docs_Result = null;
  @Output() supplierDocChange: EventEmitter<PS_Supplier_Regul_Docs_Result> = new EventEmitter<PS_Supplier_Regul_Docs_Result>();
  @Output() fileUpLoaded: EventEmitter<number> = new EventEmitter<number>();
  @Input() readonly: boolean = false;
  @ViewChild('fileUpload') fileUpload: ElementRef;
  dateInput: Date = null;
  public get requiredFileType(): string {
    return this.sharedDatasSvc.allowedExtensions.join(',');
  }
  fileName = '';
  uploadProgress: number;
  uploadSub: Subscription;

  get supplierDateExpi(): string {
    return formatDate(this.supplierDoc.DateExpi, 'dd/MM/yyyy', 'fr');
  }
  constructor(public docsSvc: DocumentsService,
    public sharedDatasSvc: SharedDataService) { }


  getDateLabel(doc: PafDocument): string {
    if (doc?.TopDatInputIsEcheance) {
      return 'Date_echeance'
    } else {
      return 'Date_document';
    }
  }

  getDateTooltip(doc: PafDocument): string {
    if (doc?.TopDatInputIsEcheance) {
      return 'La_date_doit_etre_superieure_a_la_date_du_jour'
    } else {
      return 'La_date_doit_etre_inferieure_ou_egale_a_la_date_du_jour';
    }
  }

  lastWorkFlow(docId: number): SupplierDocumentsWF {
    let doc: SupplierDocument = this.supplier.SupplierDocuments.find(sd => sd.Id == docId);
    if (!doc) return null;
    let maxId = Math.max.apply(null, doc.SupplierDocumentsWFs.map(wf => wf.Id));
    return doc.SupplierDocumentsWFs.find(wf => wf.Id == maxId);
  }

  pafDocument(doc: PS_Supplier_Regul_Docs_Result): PafDocument {
    return this.lstPafDocuments.find(d => d.Id == doc.RefDocId) || new PafDocument();
  }

  getLblCod(doc: PS_Supplier_Regul_Docs_Result): string {
    return this.pafDocument(doc)?.LblCod;
  }

  getStatutDoc(doc: PS_Supplier_Regul_Docs_Result): DocumentStatut {
    return this.lstDocStatuts.find(s => s.Id == doc.StatutId);
  }

  getFilename(doc: PS_Supplier_Regul_Docs_Result): string {
    if (!doc || !doc.FullPath) return '';
    return doc.FullPath.replace(/^.*[\\\/]/, '');
  }

  showButtonDeposer(doc: PS_Supplier_Regul_Docs_Result): boolean {
    let Cod = this.getStatutDoc(doc)?.Cod;
    if (!Cod) return false;
    if (Cod.indexOf('ARELANCER') >= 0) return true;
    return ['A_DEPOSER', 'NON_CONFORME', 'EXPIRE'].some(c => c == this.getStatutDoc(doc).Cod);
  }


  public importEncours: boolean = false;
  btnImportClick(doc: PS_Supplier_Regul_Docs_Result): void {
    const pafDoc: PafDocument = this.pafDocument(doc);
    if (pafDoc?.ImportAction) {
      this.importEncours = true;
      this.docsSvc.importAction(pafDoc.ImportAction.replace('{supplierId}', this.supplier.Id.toString()))
        .subscribe((res: SimpleReponseResult) => {
          this.importEncours = false;
          if (res.Ok) {
            this.reset();
          } else {
            this.sharedDatasSvc.alert(res.Message);
          }
        });
    }
  }


  btnDownloadTemplateClick(doc: PS_Supplier_Regul_Docs_Result): void {
    const pafDoc: PafDocument = this.pafDocument(doc);
    if (pafDoc?.TemplatePath) {
      this.docsSvc.downloadTemplate(pafDoc.Id, this.supplier?.Id)
        .subscribe({
          next: blob => {
            saveAs(blob, pafDoc?.TemplatePath);
          },
          error: err => this.sharedDatasSvc.alertSubscriptionReject("Une erreur est survenue lors du téléchargement du modèle de document.")
        });
    }
  }

  btnDownloadFileClick(doc: PS_Supplier_Regul_Docs_Result): void {
    this.docsSvc.downloadFile(this.supplier.Id, doc.DocId)
      .subscribe(blob => {
        saveAs(blob, this.getFilename(doc));
      });
  }
  btnDeleteFileClick(doc: PS_Supplier_Regul_Docs_Result): void {

    this.sharedDatasSvc.pafConfirm('Confirmer_suppression_fichier',
      (): void => { this.suppressFile(true) }
      , null);
  }

  btnArchiveFileClick(doc: PS_Supplier_Regul_Docs_Result): void {

    this.sharedDatasSvc.pafConfirm('Confirmer_archivage_fichier',
      (): void => { this.suppressFile(true) }
      , null);
  }
  suppressFile(confirmed: any) {
    if (confirmed) {
      this.docsSvc.deleteFile(this.supplier.Id, this.supplierDoc.DocId)
        .subscribe((res: SimpleReponseResult) => {
          if (res.Ok) {
            this.reset();
          } else {
            this.sharedDatasSvc.alert(res.Message);
          }
        })
    }
  }

  private fileIsDropping: boolean = false;
  onFilesDropped(event: any): void {
    let files: FileList = <FileList>event;
    if (files && files.length > 1) {
      this.sharedDatasSvc.pafAlert('telecharger_un_seul_fichier');
      this.fileUpload.nativeElement.value = "";
      return;
    }
    const file: File = files[0];
    if (file) {
      if (!this.iSExtensionAllowed(file.name)) {
        this.sharedDatasSvc.pafAlert('Extension_non_autorisee');
        this.fileUpload.nativeElement.value = "";
        return;
      }
      if (!this.isSizeAllowed(file)) {
        this.sharedDatasSvc.pafAlert('Fichier_trop_volumineux');
        this.fileUpload.nativeElement.value = "";
        return;
      }
      let pafDoc: PafDocument = this.pafDocument(this.supplierDoc);
      if (!this.controleDateInput(this.supplierDoc, true)) {
        this.fileUpload.nativeElement.value = "";
        return;
      }
      if (!this.controleDateEcheance(this.supplierDoc)) {
        this.fileUpload.nativeElement.value = "";
        return;
      }
      if (this.fileIsDropping) {
        this.sharedDatasSvc.pafAlert('Fichier_en_cours_d_import');
        this.fileUpload.nativeElement.value = "";
        return;
      }
      this.fileName = file.name;
      const formData = new FormData();
      formData.append("regulDocFile", file);
      if (pafDoc.TopInputDat == 1) {
        formData.append("dateInput", this.dateInput.toDateString());
      }
      this.fileIsDropping = true;
      const upload$ = this.docsSvc.uploadFile(this.supplier.Id, this.supplierDoc.DocId, formData)
        .pipe(
          finalize(() => {
            this.fileIsDropping = false;
            this.reset();
          })
        );

      this.uploadSub = upload$.subscribe({
        next:event => {
        if (event.type == HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(100 * (event.loaded / event.total));
        } else {
          if (event.Ok == false) {
            this.fileIsDropping = false;
            this.sharedDatasSvc.alert(event.Message);
          } 
        }
      },
        error: err => {
          this.fileIsDropping = false;
          this.sharedDatasSvc.alert(err);
        }
    });
    }
  }


  onFileSelected(event: any) {
    this.onFilesDropped(event.target.files);
  }


  controleDateInput(doc: PS_Supplier_Regul_Docs_Result, promptAlert: boolean = false): boolean {
    if (!doc) return false;
    let pafDoc: PafDocument = this.pafDocument(doc);
    if (pafDoc.TopInputDat == 1) {
      if (!this.dateInput) {
        if (promptAlert) this.sharedDatasSvc.pafAlert('Msg_Date_Manquante');
        return false;
      }
      let now = moment();
      if (pafDoc.TopDatInputIsEcheance == 1 && now.isSameOrAfter(this.dateInput, "days")) {
        if (promptAlert) this.sharedDatasSvc.pafAlert('Msg_Date_Expiration_posterieure');
        return false;
      }
      if (pafDoc.TopDatInputIsEcheance == 0 && now.isBefore(this.dateInput, "days")) {
        if (promptAlert) this.sharedDatasSvc.pafAlert('Msg_Date_Document_anterieure');
        return false;
      }
    }
    return true;
  }
  get isDateValid(): boolean {
    return this.controleDateInput(this.supplierDoc, false);
  }

  controleDateEcheance(doc: PS_Supplier_Regul_Docs_Result): boolean {
    if (!doc) return false;
    let pafDoc: PafDocument = this.pafDocument(doc);
    if (pafDoc.TopInputDat == 1 && pafDoc.Duree && pafDoc.DureeUnit) {
      let numToAdd: number = pafDoc.Duree * (pafDoc.TopDatInputIsEcheance == 1 ? 1 : -1);
      let dateLimite = moment();
      let unite: string;
      switch (pafDoc.DureeUnit) {
        case 'Y':
          dateLimite = moment().add(numToAdd, 'y');
          unite = 'an' + ((pafDoc.Duree > 1) ? 's' : '');
          break;
        case 'M':
          dateLimite = moment().add(numToAdd, 'M');
          unite = 'mois';
          break;
        case 'D':
          dateLimite = moment().add(numToAdd, 'd');
          unite = 'jour' + ((pafDoc.Duree > 1) ? 's' : '');
          break;
        default:
          dateLimite = moment().add(numToAdd * 100, 'y');
      }
      if (unite) {
        if ((pafDoc.TopDatInputIsEcheance == 1 && dateLimite.isSameOrBefore(this.dateInput, "days"))
          || (pafDoc.TopDatInputIsEcheance == 0 && dateLimite.isAfter(this.dateInput, "days"))) {
          this.sharedDatasSvc.getLabel('Duree_limite_de_validite')
            .subscribe(res => {
              this.sharedDatasSvc.alert(res + ' : ' + pafDoc.Duree.toString() + ' ' + unite);
            });
          return false;
        }
      }
    }
    return true;
  }


  isSizeAllowed(file: File): boolean {
    return file.size <= this.sharedDatasSvc.maxFileSize;
  }
  iSExtensionAllowed(filename: string): boolean {
    let ext = ('.' + filename.split('.')[filename.split('.').length - 1]).toUpperCase();
    return this.sharedDatasSvc.allowedExtensions.some(e => e == ext);
  }

  isDownloadDisabled(): boolean {
    return this.pafDocument(this.supplierDoc).TopInputDat == 1
      && (this.dateInput == null || !this.controleDateInput(this.supplierDoc));
  }


  reset() {
    this.uploadProgress = null;
    this.uploadSub = null;
    this.supplierDocChange.emit(this.supplierDoc);

    // let refDocId: number = this.supplierDoc?.RefDocId;
    // forkJoin([
    //   this.docsSvc.getSupplierRegulDocs(this.sharedDatasSvc.lngCod, this.supplier.Id),
    //   this.docsSvc.getSupplierDocuments(this.supplier.Id)
    // ])
    //   .subscribe(res => {
    //     this.supplierDoc = res[0].find(d => d.RefDocId == refDocId);
    //     let doc: SupplierDocument = res[1].find(d => d.RefDocId == refDocId);
    //     this.supplierDocChange.emit(this.supplierDoc);
    //     this.supplier.SupplierDocuments = this.supplier.SupplierDocuments.filter(d => d.RefDocId != refDocId);
    //     this.supplier.SupplierDocuments.push(doc);
    //   });
  }

  getStatutLib(doc: PS_Supplier_Regul_Docs_Result): Observable<string> {
    return of(doc.DisplayedStatut);
  }

  statutNgClass(doc: PS_Supplier_Regul_Docs_Result): any {
    const statut = this.getStatutDoc(doc);
    if (!statut) return "";
    return {
      'badge': true,
      'badge-success': ['CONFORME', 'RELANCE-20', 'RELANCE-10', 'RELANCE-5'].indexOf(statut.Cod) >= 0 && doc.TopExpire == 0,
      'badge-warning': doc.TopExpire == 1 || ['A_DEPOSER', 'EXPIRE', 'RELANCE-J', 'RELANCE+10', 'RELANCE+20', 'RELANCE+30'].indexOf(statut.Cod) >= 0,
      'badge-secondary': statut.Cod == 'A_VALIDER',
      'badge-danger': ['NON_CONFORME'].indexOf(statut.Cod) >= 0,
      'badge-info': statut.Cod.indexOf('ARELANCER') == 0
    };
  }

  isExpired(doc: PS_Supplier_Regul_Docs_Result): boolean {
    if (!doc) return false;
    return doc.DateExpi != null && moment().isSameOrAfter(doc.DateExpi);
  }


  get dateFormatPalceHolder(): any {
    return {
      year: '____', month: '__', day: '__'
    };
  }

  get btnUploadTooltip(): string {
    if (!this.isDownloadDisabled()) {
      return 'Cliquer_ou_faire_glisser_le_fichier_ici';
    } else {
      return 'La_saisie_de_la_date_est_requise';
    }
  }

  get canDeleteFile(): boolean {
    if (this.readonly) return false;
    return this.supplierDoc?.CanDelete == 1;
  }

  get showFileLink(): boolean {
    return this.supplierDoc.FullPath && !(this.supplierDoc.SupplierStatutCod >= '800' && this.isExpired(this.supplierDoc));
  }

  get canArchiveFile(): boolean {
    if (this.readonly) return false;
    if (this.canUploadFile) return false;
    return this.supplierDoc?.CanArchive == 1;
  }

  get canUpdateFile(): boolean {
    if (this.readonly) return false;
    //if (this.readonly && !this.docAdminProfil) return false;
    let pafDoc: PafDocument = this.pafDocument(this.supplierDoc);
    return pafDoc?.ImportAction != null;
  }
  get canDownloadTemplate(): boolean {
    let pafDoc: PafDocument = this.pafDocument(this.supplierDoc);
    return pafDoc?.TemplatePath != null;
  }

  get canUploadFile(): boolean {
    //if (this.readonly) return false;
    //return this.supplierDoc?.FullPath == null|| this.isExpired(this.supplierDoc);
    return this.supplierDoc?.CanUpload == 1 && this.uploadProgress == null;
  }

  get showExpiredLabel(): boolean {
    return !this.ShowDateInput && this.supplierDoc.FullPath && this.pafDocument(this.supplierDoc).TopInputDat == 1 && this.isExpired(this.supplierDoc) && this.supplierDoc.SupplierStatutCod < '800';
  }
  get showExpireLeLabel(): boolean {
    return !this.ShowDateInput && this.supplierDoc.FullPath && this.pafDocument(this.supplierDoc).TopInputDat == 1 && !this.isExpired(this.supplierDoc);
  }

  get ShowDateInput(): boolean {
    return this.canUploadFile && this.pafDocument(this.supplierDoc).TopInputDat == 1 && !this.readonly;
  }
  validDoc(doc: PS_Supplier_Regul_Docs_Result): void {
    if (!doc || !this.supplier) return;
    let params: ChangeStatutParams = new ChangeStatutParams();
    params.SupplierId = this.supplier.Id;
    params.documentId = doc.DocId;
    params.CurrentStatutId = doc.StatutId;
    params.NewStatutId = this.lstDocStatuts.find(ds => ds.Cod == 'CONFORME').Id;
    this.docsSvc.ChangeStatut(this.supplier.Id, params)
      .subscribe((res: SimpleReponseResult) => {
        if (!res.Ok) {
          this.sharedDatasSvc.alert(res.Message);
        } else {
          this.reset();
        }
      });
  }

  rejectDoc(doc: PS_Supplier_Regul_Docs_Result): void {
    if (!doc || !this.supplier) return;
    let params: ChangeStatutParams = new ChangeStatutParams();
    params.SupplierId = this.supplier.Id;
    params.documentId = doc.DocId;
    params.CurrentStatutId = doc.StatutId;
    params.NewStatutId = this.lstDocStatuts.find(ds => ds.Cod == 'NON_CONFORME').Id;
    this.sharedDatasSvc.pafPrompt('Saisir_un_motif_de_rejet',
      (motifRejet: string): void => {
        params.Comments = motifRejet;
        this.docsSvc.ChangeStatut(this.supplier.Id, params)
          .subscribe((res: SimpleReponseResult) => {
            if (!res.Ok) {
              this.sharedDatasSvc.alert(res.Message);
            } else {
              this.reset();
            }
          });
      });
  }

  // get docAdminProfil(): boolean {
  //   return (['ADMIN','CTRL_QUAL','COMPTA'].indexOf(this.sharedDatasSvc.profil?.Cod)>=0);
  // }
  get canReject(): boolean {
    return this.supplierDoc?.CanReject == 1;
    // if (!this.supplierDoc) return false;    
    // if (['ADMIN','CTRL_QUAL','COMPTA'].indexOf(this.sharedDatasSvc.profil?.Cod)<0) return false;
    // let docStatut: DocumentStatut=this.getStatutDoc(this.supplierDoc);
    // return (this.supplierDoc.FullPath && !this.pafDocument(this.supplierDoc)?.ImportAction 
    //   && !['NON_CONFORME','EXPIRE','A_DEPOSER','ARELANCER1','ARELANCER2','ARELANCER3','ARELANCER4'].some(cod=>docStatut && docStatut.Cod==cod));
  }
  get canAccept(): boolean {
    return this.supplierDoc?.canAccept == 1;
    // if (!this.supplierDoc) return false;
    // if (['ADMIN','CTRL_QUAL','COMPTA'].indexOf(this.sharedDatasSvc.profil?.Cod)<0) return false;
    // let docStatut: DocumentStatut=this.getStatutDoc(this.supplierDoc);
    // return (this.supplierDoc.FullPath && !this.pafDocument(this.supplierDoc)?.ImportAction 
    //   && !['CONFORME','EXPIRE','A_DEPOSER','ARELANCER1','ARELANCER2','ARELANCER3','ARELANCER4'].some(cod=>docStatut && docStatut.Cod==cod));
  }

  get popupStatut(): string {
    if (!this.supplierDoc || this.sharedDatasSvc.profil?.Cod == 'FOURNISSEUR' || !this.getStatutDoc(this.supplierDoc)) return '';
    let ret: string = '';
    let strDate: string = new Date(this.supplierDoc.DatStatut).toLocaleDateString();
    if (this.getStatutDoc(this.supplierDoc).Cod == 'CONFORME') {
      return 'Validé le ' + strDate + ' par ' + this.supplierDoc?.UserStatut;
    } else if (this.getStatutDoc(this.supplierDoc)?.Cod == 'NON_CONFORME') {
      return 'Rejeté le ' + strDate + ' par ' + this.supplierDoc?.UserStatut + ' motif: ' + this.supplierDoc?.Comments;
    } else {
      return '';
    }
  }

  get showRibMessage():boolean {
    return this.sharedDatasSvc.portalType=='EXTRANET'
    && this.supplierDoc && this.supplierDoc.Cod=='RIB_INFO' 
    && (this.canDeleteFile || this.canArchiveFile);
  }


}
